// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"_3-vb2YTh","image":"_1B7AOayj","title":"_2LVNgNPh","description":"_3sbwV9Cd","step":"_3gqchGL7","icon":"_1-9dd1-e","stepText":"_2rupLBMT"};